import lang from "translations";

const columns = [
  {
    key: "name",
    text: lang.name,
    custom: true,
    width: "w-2/4",
  },
  {
    key: "locationName",
    text: lang.location,
    custom: true,
    width: "w-2/4",
  },
  {
    key: "isActive",
    text: lang.status,
    custom: true,
    width: "w-1/4",
  },
];

export default columns;
